module.exports = __webpack_public_path__ + "mf-im.jpg?b0145e0b8314c9ae812ae00503ba68ff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mf-im.jpg
// module id = 225
// module chunks = 0